module.exports = __webpack_public_path__ + "img/perforaciones_9-16_1620.4c71e625.jpg";